module.exports = __webpack_public_path__ + "img/account_100.6b728ed2.jpg";